export default "__VITE_PUBLIC_ASSET__7928c005__"